module.exports = (__webpack_require__(31336))(96);